export const ROUTE_ROOT = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_MENTIONS_LEGALES = '/mentions-legales';

// ROUTEs B2C - B2B
export const ROUTE_B2B_B2C_SELECTOR = '/b2b-b2c-selector';

const B2C_PREFIX = process.env.REACT_APP_B2C_PREFIX;
const B2B_PREFIX = process.env.REACT_APP_B2B_PREFIX;

export const ROUTE_B2B_EA = `${B2B_PREFIX}/espace-agent`;
export const ROUTE_B2C_EA = `${B2C_PREFIX}/espace-agent`;
